<template>
  <div>
    <div>
      <div class="flex justify-start whs mb-5">
        <div v-for="wh in whs" :key="wh.key" class="wh" :class="{'active':curWh == wh.key}" @click="setWh(wh.key)">
          {{ wh.name }}
        </div>
      </div>
      <div class="default">
        <div class="flex-shrink-0 text-left">{{ $t("分类") }}：</div>

        <div :class="['classify', more]">
          <div class="mx-4 transition ease-linear cursor-pointer mb-4 hover:text-mainHigh"
            :class="{ select: item.id === Number(checkedId) }" v-for="item in classify_list" :key="item.id"
            @click="select(item.id)">
            {{ item.name }}
          </div>
        </div>
        <div class="flex-shrink-0 text-right flex-grow" @click="isHide = !isHide">
          <el-link type="info" :underline="false" target="_blank" v-show="isHide">
            {{ $t("更多") }}
            <span class="iconfont icon-xiangxia text-0.5rem"></span>
          </el-link>
          <el-link type="info" :underline="false" target="_blank" v-show="!isHide">
            {{ $t("收起") }}
            <span class="iconfont icon-xiangshang text-0.5rem"></span>
          </el-link>
        </div>
      </div>
      <div class="default mt-6" v-if="checkedId">
        <div class="flex-shrink-0 text-left">{{ $t("颜色搜索") }}：</div>
        <div>
          <div class="inline-block" v-for="(val, key) in colorsList" :key="key" @click="selectColor(val)">
            <span class="mx-2 cursor-pointer" :class="{ color: val === checkedColor }">{{ val }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import { getClassifyList } from "/src/API/product/getClassifyList.js";

export default {
  setup(props, ctx) {
    const isHide = ref(true);
    const more = ref({ more: isHide });
    const checkedId = ref(ctx.root.$route.query.classify_id);
    let classify_list = getClassifyList(props, ctx, {});
    const colorsList = ref();

    const getColorsList = async () => {
      if (checkedId.value && Number(checkedId.value)) {
        const res = await ctx.root.$callapi("getColorByClassfiy", {
          classify_id: checkedId.value,
        });
        colorsList.value = res.data;
      }
    };
    onMounted(() => {
      getColorsList();
      checkedColor.value = ctx.root.$route.query.color;
      curWh.value = ctx.root.$route.query.wh || 'origin'
    });
    //选择分类商品
    const select = (id) => {
      checkedId.value = id;
      checkedColor.value = null;

      if (checkedId.value === id) {
        getColorsList();
        if (ctx.root.$route.query.color) {
          //删除路由中的颜色参数
          let newQuery = JSON.parse(JSON.stringify(ctx.root.$route.query));
          delete newQuery.color;
          delete newQuery.page;
          ctx.root.$router
            .replace({ name: "Product", query: newQuery })
            .catch(() => { });
        } else {
          ctx.root.$router
            .replace({
              name: "Product",
              query: { ...ctx.root.$route.query, classify_id: id, page: 1,wh:curWh.value },
            })
            .catch(() => { });
        }
      }
    };
    const checkedColor = ref(null);
    //从颜色选择分类商品
    const selectColor = (e) => {
      checkedColor.value = e;
      ctx.root.$router
        .replace({
          name: "Product",
          query: {
            ...ctx.root.$route.query,
            classify_id: checkedId.value,
            color: e,
            page: 1,
            wh:curWh.value
          },
        })
        .catch(() => { });
    };
     
    const curWh = ref('origin')

    const whs = [
      {
        key: 'origin',
        name: ctx.root.$t('现货')
      },
      {
        key: 'presell',
        name: ctx.root.$t('预售-CIF')
      }
    ]
    
    const setWh = (wh)=>{
      curWh.value = wh
      ctx.root.$router
        .replace({
          name: "Product",
          query: {
            ...ctx.root.$route.query,
            classify_id: checkedId.value,
            page: 1,
            wh:curWh.value
          },
        })
        .catch(() => { });

    }

    return {
      isHide,
      more,
      classify_list,
      select,
      colorsList,
      checkedId,
      selectColor,
      checkedColor,
      whs,
      curWh,
      setWh
    };
  },
};
</script>

<style scoped lang="scss">.default {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.classify {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
}
.color {
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}
.more :nth-child(n + 16) {
  display: none;
}
.mores {
  font-size: 26px;
  position: relative;
  font-weight: 100;
  top: 12px;
  line-height: 0.1rem;
}
.select {
  background-color: #34b66b;
  color: #ffffff;
  border-radius: 0.781rem;
  padding: 0.1rem 0.7rem;
}
.wh {
  font-size: 1rem;
  margin-right: 2rem;
  cursor: pointer;
}
.wh.active {
  position: relative;
  color: #34B66B;
  font-size: 1.12rem;
  font-weight: bold;
  z-index: 0;
}
.wh.active:after {
  position: absolute;
  content: '';
  display: block;
  bottom: 5px;
  left: 0;
  width: 30px;
  height: 6px;
  background: linear-gradient(90deg, #ffbb00 -4.05%, #fefefe 95.95%);
  z-index: -1;
}</style>
